import { IStyle } from '@fluentui/react';
export interface ICardListStyles {
  root?: IStyle;
  item?: IStyle;
}

export const cardListStylesDefault: ICardListStyles = {
  root: {
    display: 'grid',
    '& .h2o-CardList-item--2by1 .h2o-Card-thumbnailImage::after': {
      paddingBottom: '45%',
    },
  },
  item: {
    position: 'relative',
  },
};

export const cardListStylesNoGap: ICardListStyles = {
  root: {
    marginTop: 0,
    marginLeft: 0,
  },
  item: {
    marginTop: 0,
    marginLeft: 0,
  },
};

export const cardListStylesDashboard: ICardListStyles = {
  root: {
    height: '100%',
  },
  item: {
    maxWidth: 287,
  },
};
